import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { getErrorMessage } from '@/utils/errorMessage';
import { QuestionsService } from '../questions.service';

export const useCreateQuestion = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	const createQuestionMutation = useMutation({
		mutationFn: (body: Questions.Create) => QuestionsService.create(body),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['questions'] });
			toast.success('Faq criada com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(getErrorMessage(error, 'Erro na criação da faq'));
		},
	});

	return createQuestionMutation;
};

export const useDeleteQuestion = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	const deleteQuestionMutation = useMutation({
		mutationFn: (id: string) => QuestionsService.destroy(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['questions'] });
			toast.success('Faq deletada com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(getErrorMessage(error, 'Erro no delete da faq'));
		},
	});

	return deleteQuestionMutation;
};

export const useUpdateQuestion = (onSuccess?: () => void) => {
	const queryClient = useQueryClient();

	const updateQuestionMutation = useMutation({
		mutationFn: ({ id, body }: { id: string; body: Questions.Create }) =>
			QuestionsService.update({ id, body }),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['questions'] });
			toast.success('Faq atualizada com sucesso!');
			if (onSuccess) onSuccess();
		},
		onError: (error: unknown) => {
			toast.error(getErrorMessage(error, 'Erro na atualização da faq'));
		},
	});

	return updateQuestionMutation;
};
